import React, { useState } from 'react';
import { BUSINESS } from '../../config/seo';
import './Footer.css';

interface FooterProps {
    onBulkOrderClick?: () => void;
    onEnquireClick?: () => void;
}

const Footer: React.FC<FooterProps> = ({ onBulkOrderClick, onEnquireClick }) => {
    const [email, setEmail] = useState('');

    const handleNotify = (e: React.FormEvent) => {
        e.preventDefault();
        if (email.trim()) {
            window.location.href = `mailto:${BUSINESS.email}?subject=Newsletter%20Subscription&body=Please%20notify%20me%20at%20${encodeURIComponent(email)}`;
            setEmail('');
        }
    };

    return (
        <footer id="contact" className="footer">
            <section className="footer-newsletter">
                <div className="container footer-newsletter__inner">
                    <h2 className="footer-newsletter__title">More threads,<br />more often</h2>
                    <p className="footer-newsletter__text">
                        Stay in touch for new collections, weaving stories, and exclusive offers.
                    </p>
                    <form className="footer-newsletter__form" onSubmit={handleNotify}>
                        <input
                            type="email"
                            placeholder="Enter your email..."
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <button type="submit" className="pill-btn pill-btn--outline footer-notify-btn">
                            Notify Me
                        </button>
                    </form>
                </div>
            </section>

            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <h3>Namma Nesavu Nool</h3>
                        <p>Preserving the art of handloom weaving. Every thread woven with care, every pattern telling a story of traditional craftsmanship.</p>
                    </div>

                    <div className="footer-section">
                        <h4>Products</h4>
                        <ul>
                            <li><a href="#categories">Categories</a></li>
                            <li><a href="#categories" onClick={(e) => { e.preventDefault(); onBulkOrderClick?.(); }}>Bulk Orders</a></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Explore</h4>
                        <ul>
                            <li><a href="#about">About Us</a></li>
                            <li><a href="#our-work">Our Work</a></li>
                            <li><a href="#contact">Contact</a></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Contact</h4>
                        <div className="contact-item">
                            <a href={`tel:${BUSINESS.phone}`}>{BUSINESS.phoneDisplay}</a>
                        </div>
                        <div className="contact-item">
                            <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>
                        </div>
                        <div className="contact-item">
                            <address>
                                {BUSINESS.addressLocality}, {BUSINESS.addressRegion} {BUSINESS.postalCode}
                            </address>
                        </div>
                        <div className="contact-item">
                            <a
                                href={BUSINESS.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="instagram-link-footer"
                            >
                                Instagram
                            </a>
                        </div>
                    </div>
                </div>

                <div className="footer-actions">
                    {onEnquireClick && (
                        <button className="pill-btn pill-btn--outline" onClick={onEnquireClick}>
                            Enquire Now
                        </button>
                    )}
                    {onBulkOrderClick && (
                        <button className="pill-btn pill-btn--light footer-bulk-btn" onClick={onBulkOrderClick}>
                            Bulk Orders
                        </button>
                    )}
                </div>

                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} Namma Nesavu Nool. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
